//CSS
import '../../Components/Page/Page.css';

//React
import React from "react";
import Header2 from "../../Components/Header2/Header2";
import Footer from "../../Components/Footer/FooterSmall";
import BusinessModel from '../../Content/Business Model/BusinessModel';
import RevenueScenario from '../../Content/RevenueScenario/RevenueScenario';
import HighROI from '../../Content/HighROI/HighROI';
import DeRisking from '../../Content/DeRisking/DeRisking';
import Competition from '../../Content/Competition/Competition';
import ElfPower from '../../Content/ElfPower/ElfPower';
import GoToMark from '../../Content/GoToMark/GoToMark';


const Investment: React.FC = () => {

    return (
        <div className='generalPage'>
            <Header2 />
            <div className='pageContainer'>
                <ElfPower/>
                <BusinessModel/>
                <RevenueScenario/>
                <GoToMark/>
                <HighROI/>
                <DeRisking/>
                <Competition/>
            </div>
            <Footer />
        </div>
    );
};

export default Investment;